module.exports = __webpack_public_path__ + "static/media/passwordBanner.82d0bf37.png";